import { cx } from "@emotion/css";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import IconButton from "@mui/material/IconButton";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import routing from "routing";
import { BackButton } from "src/components/Default/LekUI/BackButton";
import FinishedExamShortView from "src/components/NewComponents/Exams/ShortExamView/FinishedExamsShortView";
import UnfinishedExamShortView from "src/components/NewComponents/Exams/ShortExamView/UnfinishedExamsShortView";
import ExamIcon from "src/images/Icons/newIcons/navigation/exams.svg";

import { Tooltip } from "../../Default/LekUI/Tooltip";
import Box from "../../Default/Main/Box";

interface HeaderProps {
	className?: string;
	icon?: ReactNode;
	title: string;
	onShowAll?: () => void;
	onCreate?: () => void;
	onCreateTooltip?: string;
	onShowAllTooltip?: string;
	Search?: ReactNode;
	additionalActions?: ReactNode;
	titleClassName?: string;
	withBackButton?: boolean;
}

export const Header = ({
	className,
	icon,
	title,
	onShowAll,
	onCreate,
	onCreateTooltip,
	onShowAllTooltip,
	Search = null,
	additionalActions = null,
	titleClassName,
	withBackButton = false,
}: HeaderProps) => {
	return (
		<div className={cx(className, "flex items-center justify-between w-100 flex-1")}>
			<div className={cx(titleClassName, "flex-center-row gap-8")}>
				<div className="flex gap-4 items-center">
					{withBackButton && <BackButton />}
					{icon}
					<h2 className="h2">{title}</h2>
				</div>
				{onShowAll && (
					<Tooltip title={onShowAllTooltip}>
						<IconButton
							size="small"
							className="text-black p-0"
							onClick={onShowAll}
							disableRipple
						>
							<ArrowForwardRoundedIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				)}
				{additionalActions}
			</div>
			{onCreate && (
				<Tooltip title={onCreateTooltip}>
					<IconButton
						size="small"
						className="menu-icon-button"
						onClick={onCreate}
						disableRipple
					>
						<AddRoundedIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			)}
			{Search}
		</div>
	);
};

function ExamsBox() {
	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState(0);
	const history = useHistory();

	const renderContent = () => {
		if (selectedTab === 0) {
			return <UnfinishedExamShortView />;
		}

		return <FinishedExamShortView />;
	};

	return (
		<Box
			tabs={[t("table.exam.tabs.unfinished"), t("table.exam.tabs.finished")]}
			onTabsChange={setSelectedTab}
			selectedTab={selectedTab}
			Header={
				<Header
					title={t("table.exam.title")}
					icon={<ExamIcon className={cx("icon-super-big icon-primary")} />}
					onShowAll={() => {
						history.push(routing.paths.examsList);
					}}
					onCreateTooltip={t("tooltips.createNewExam")}
					onShowAllTooltip={t("tooltips.showAllExams")}
					onCreate={() => {
						history.push(routing.paths.pickExamType);
					}}
				/>
			}
			showAllLink={routing.paths.examsList}
		>
			<div>{renderContent()}</div>
		</Box>
	);
}

export default ExamsBox;
